module.exports = __webpack_public_path__ + "assets/static/svg/mobile.eaf4abb5312ca05300b7ba38d490f429.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/receipt/images/mobile.svg
 ** module id = 526
 ** module chunks = 1
 **/